import React, { Suspense } from "react";
import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import brightspeedTheme from "./brightspeedTheme";
import AllRoutes from "./Routes";
import store from "./SharedContextStore/store";
import closeIcon from "./assets/images/tostCloseIcon.svg";
import "./App.css";
import "./assets/styles/globals.scss";
import "./assets/styles/mui.scss";
import "./assets/styles/main.scss";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./SharedComponents/ErrorFallback";
import { Backdrop } from "@mui/material";
import useNewOptimizelyConsent from "./hooks/useNewOptimizelyConsent";
import useOptimizelyInitialization from "./hooks/useOptimizelyInitialization";
import GlobalToastLiveAnnouncer from "./SharedComponents/GlobalToastLiveAnnouncer";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    dashed: true;
  }
}

const ToastCloseButton = ({ closeToast }: any) => (
  <img
    onClick={closeToast}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        closeToast();
      }
    }}
    tabIndex={0}
    src={closeIcon}
    alt="close toast container"
    className="cursor-pointer tostCloseIcon"
  />
);

function App() {
  const theme = brightspeedTheme;

  // Consent first (cookie / GPC / OneTrust migration), then Optimizely script load
  useNewOptimizelyConsent();
  useOptimizelyInitialization();

  return (
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Suspense fallback={
                <Backdrop className="custom-loader-backdrop" open={true}>
                  <div className="custom-loader"></div>
                </Backdrop>
              }>
                <Router>
                  <AllRoutes />
                </Router>
              </Suspense>
            </ErrorBoundary>
            <CssBaseline />
            <ToastContainer
              position="bottom-center"
              autoClose={10000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              icon={false}
              toastStyle={{
                backgroundColor: "black",
                color: "white",
                bottom: "16px",
              }}
              closeButton={ToastCloseButton}
            />
            <GlobalToastLiveAnnouncer />
        </Provider>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
